.enable-calendar {
    padding: 24px;
}
